import { Button, Grid, Skeleton } from "@mui/material";
import React, { useEffect, useState } from "react";
import ProductsImages from "./productImages";
import ProductRegistration from "./productRegistration";
import ProductSpecifications from "./productSpecifications";
import Header from "../header";
import { useMutation } from "react-query";
import { ApiResultModel } from "../../../models/common.model";
import { GetProductDetailResponse, OpenOrder } from "../../models/store.model";
import {
  GetProductDetail,
  GetProductPriceInfo,
} from "../../service/store.service";
import { useHistory } from "react-router-dom";
import { PRODUCT_KEY } from "../../../config/cacheKey";
import ProductDetailSkeleton from "./productDetailSkeleton";
import { useDebouncedCallback } from "use-debounce";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
export default function ProductDetail() {
  const [gallery, setGallery] = useState<string[]>();
  const [detailData, setDetailData] = useState<GetProductDetailResponse>();
  const [openOrder, setOpenOrder] = useState<OpenOrder>();
  const [count, setCount] = useState<number>(0);
  const [notEffectCount, setNotEffectCount] = useState<boolean>(true);
  const [reloadOnRegister, setReloadOnRegister] = useState<string>("");
  const [reloadOnDelete, setReloadOnDelete] = useState<string>("");
  const [orderIdState, setOrderId] = useState<number>(0);
  const [inventoryId, setInventoryId] = React.useState(
    detailData?.colorOptions[0].inventoryId
  );
  const history = useHistory<{
    key: string;
    title?: string;
    inventoryId?: number;
    path?: any[];
  }>();
  useEffect(() => {
    // history.push({
    //   state: {
    //     title
    //   },
    // });
    const key = history.location.state?.key
      ? history.location.state.key
      : sessionStorage.getItem(PRODUCT_KEY);

    if (key) {
      GetDetail({
        key: key!,
      });
    }
  }, []);
  useEffect(() => {
    if (reloadOnRegister) {
      openOrder!.orderId = orderIdState;
      openOrder!.count = count;
      detailData?.openOrders.push(openOrder!);
      setDetailData(detailData);
    }
  }, [reloadOnRegister]);
  useEffect(() => {
    if (reloadOnDelete) {
      let updateDetailData = detailData?.openOrders.filter((i: any) => {
        return i.inventoryId !== openOrder?.inventoryId;
      });
      detailData!.openOrders = updateDetailData!;
      setDetailData(detailData);
      setCount(0);
      // setOrderId(0);
    }
  }, [reloadOnDelete]);

  useEffect(() => {
    let orderId: number | undefined;
    let countService: number | undefined;
    let inventoryIdFilter = detailData?.openOrders.filter(
      (item: OpenOrder) => item.inventoryId == inventoryId!
    );
    let inventoryIdColorFilter = detailData?.colorOptions.filter(
      (item: any) => item.inventoryId == inventoryId!
    );
    if (detailData?.openOrders!?.length > 0) {
      if (inventoryIdFilter && inventoryIdFilter!.length > 0) {
        orderId = inventoryIdFilter![0].orderId;
        countService = inventoryIdFilter![0].count;
      } else if (inventoryIdColorFilter && inventoryIdColorFilter!.length > 0) {
        orderId = 0;
        countService = 0;
      } else if (inventoryIdFilter == undefined) {
        orderId = detailData?.openOrders[0].orderId;
        countService = detailData?.openOrders[0].count;
      }
    } else {
      orderId = 0;
      countService = 0;
    }
    setOrderId(orderId!);
    if (inventoryId) {
      if (orderId! > 0) {
        GetPrceInfo_Inventory({
          orderId,
          inventoryId: inventoryId!,
          count: countService!,
        });
      } else {
        GetPrceInfo_Inventory({
          inventoryId: inventoryId!,
          count: countService!,
        });
      }
    }
  }, [inventoryId]);

  useEffect(() => {
    let orderId: number | undefined;
    let countService: number | undefined;
    let inventoryIdFilter = detailData?.openOrders.filter(
      (item: OpenOrder) => item.inventoryId == inventoryId!
    );
    let inventoryIdColorFilter = detailData?.colorOptions.filter(
      (item: any) => item.inventoryId == inventoryId!
    );
    if (detailData?.openOrders!?.length > 0) {
      if (inventoryIdFilter && inventoryIdFilter!.length > 0) {
        orderId = inventoryIdFilter![0].orderId;
        countService = inventoryIdFilter![0].count;
      } else if (inventoryIdColorFilter && inventoryIdColorFilter!.length > 0) {
        orderId = 0;
        countService = 0;
      } else if (inventoryIdFilter == undefined) {
        orderId = detailData?.openOrders[0].orderId;
        countService = detailData?.openOrders[0].count;
      }
    } else {
      orderId = 0;
      countService = 0;
    }
    setOrderId(orderId!);

    if (inventoryId && notEffectCount == false && Number(count) > 0) {
      pricInfoCall(orderId!, inventoryId, count);
      // if (orderId! > 0) {
      //   GetPrceInfo({
      //     orderId,
      //     inventoryId: inventoryId!,
      //     count,
      //   });
      // } else {
      //   GetPrceInfo({
      //     inventoryId: inventoryId!,
      //     count,
      //   });
      // }
    }
  }, [count]);
  const pricInfoCall = useDebouncedCallback(
    (orderId: number, inventoryId: number, count: any) => {
      if (orderId! > 0) {
        GetPrceInfo({
          orderId,
          inventoryId: inventoryId!,
          count,
        });
      } else {
        GetPrceInfo({
          inventoryId: inventoryId!,
          count,
        });
      }
    },
    500
  );
  const { mutate: GetDetail, isLoading: productDetailIsLoding } = useMutation(
    GetProductDetail,
    {
      onSuccess: (data: ApiResultModel<GetProductDetailResponse>) => {
        if (data.data) {
          setDetailData(data.data);
          setInventoryId(
            data.data.openOrders.length > 0
              ? history.location.state?.inventoryId
                ? history.location.state?.inventoryId
                : data.data.openOrders[0].inventoryId
              : data.data?.colorOptions[0].inventoryId
          );
          setGallery(data.data.gallery);
          setOpenOrder(data.data.openOrders[0]);
          setCount(data.data.openOrders[0]?.count!);
          history.replace({
            state: {
              key: history.location.state?.key,
              path: data.data.categoryPath,
              title: data?.data.title,
            },
          });
        } else {
          setCount(0);
        }
      },
    }
  );
  const { mutate: GetPrceInfo, isLoading: islodingPriceInfo } = useMutation(
    GetProductPriceInfo,
    {
      onSuccess: (data: ApiResultModel<OpenOrder>) => {
        if (data.data) {
          setOpenOrder(data.data);
        }
      },
    }
  );
  const { mutate: GetPrceInfo_Inventory } = useMutation(GetProductPriceInfo, {
    onSuccess: (data: ApiResultModel<OpenOrder>) => {
      if (data.data) {
        setNotEffectCount(true);
        setOpenOrder(data.data);
        if (!data.data.orderId) {
          setCount(0);
        } else {
          setCount(data.data.count! ? data.data.count : 0);
        }
      }
    },
  });

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Header search={true} category={true} parentCategoryId={undefined} />
        </Grid>
        {detailData ? (
          <>
            <Grid item xs={12} sm={5} md={3} lg={3} xl={3} width={"100%"}>
              <ProductsImages gallery={gallery} />
            </Grid>
            <Grid item xs={12} sm={7} md={5} lg={5} xl={6}>
              <ProductSpecifications
                detailData={detailData}
                setInventoryId={setInventoryId}
                inventoryId={inventoryId}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
              {!islodingPriceInfo ? (
                <ProductRegistration
                  openOrder={openOrder}
                  setCount={setCount}
                  count={count}
                  inventoryId={inventoryId}
                  orderId={orderIdState}
                  setInventoryId={setInventoryId}
                  setOrderId={setOrderId}
                  setNotEffectCount={setNotEffectCount}
                  setReloadOnRegister={setReloadOnRegister}
                  setReloadOnDelete={setReloadOnDelete}
                />
              ) : (
                <Grid
                  container
                  spacing={2}
                  style={{
                    border: "1px solid #E0E0E0",
                    borderRadius: "5px",
                    padding: "0 20px 20px 20px ",
                    marginBottom: "5px",
                    boxSizing: "border-box",
                  }}
                  className="colorTitle "
                >
                  <Grid
                    item
                    xs={12}
                    style={{
                      borderBottom: "1px solid #E0E0E0",
                      borderRadius: "5px",
                      padding: "4px 0px 0px 0px ",
                    }}
                    className="paddingGrid"
                  >
                    <Skeleton width={"100%"} height={30} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{
                      borderBottom: "1px solid #E0E0E0",
                      padding: "16px 0px 0px 0px ",
                    }}
                    className="paddingGrid"
                  >
                    <Skeleton
                      style={{ marginTop: "-10px" }}
                      width={"100%"}
                      height={30}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ padding: "16px 0px 0px 0px " }}>
                    <Skeleton width={"100%"} height={30} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    style={{
                      borderBottom: "1px solid #E0E0E0",
                    }}
                    className="paddingGrid"
                  >
                    <Grid item xs={2} sx={{ alignItems: "center" }}>
                      <Skeleton width={"80%"} height={30} />
                    </Grid>
                    <Grid
                      item
                      xs={3}
                      style={{ alignItems: "center", marginTop: "-20px" }}
                    >
                      <Skeleton width={"100%"} height={60} />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        alignItems: "center",
                        justifyContent: "left",
                        marginRight: "3vh",
                      }}
                    >
                      <Skeleton width={"100%"} height={30} />
                    </Grid>
                  </Grid>

                  <Grid
                    xs={12}
                    container
                    // spacing={2}
                    style={{
                      borderBottom: "1px solid #E0E0E0",
                      marginTop: "10px",
                    }}
                    className="paddingGrid"
                  >
                    <Grid item xs={6}>
                      <Skeleton width={"80%"} height={30} />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        textAlign: "left",
                        color: "#424242",
                      }}
                    >
                      <Skeleton width={"80%"} height={30} />
                    </Grid>
                    <br />
                    <br />
                    <Grid item xs={6}>
                      <Skeleton width={"80%"} height={30} />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        textAlign: "left",
                        color: "#424242",
                      }}
                    >
                      <Skeleton width={"80%"} height={30} />
                    </Grid>
                    <br />
                    <br />
                    <Grid item xs={6}>
                      <Skeleton width={"80%"} height={30} />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        textAlign: "left",
                        color: "#424242",
                      }}
                    >
                      <Skeleton width={"80%"} height={30} />
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Skeleton width={"80%"} height={30} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ textAlign: "left", fontSize: "1.5em" }}
                    className="colorOk"
                  >
                    <Skeleton width={"100%"} height={30} />
                  </Grid>
                  <Grid item xs={12}>
                    <Skeleton
                      width={"100%"}
                      height={70}
                      style={{ marginTop: "60px" }}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </>
        ) : (
          <ProductDetailSkeleton />
        )}
      </Grid>
    </>
  );
}
